import { NotificationManager } from 'react-notifications'

export default NotificationManager